import { render, staticRenderFns } from "./Newspaper.vue?vue&type=template&id=276c65c0&"
import script from "./Newspaper.vue?vue&type=script&lang=ts&"
export * from "./Newspaper.vue?vue&type=script&lang=ts&"
import style0 from "./Newspaper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports